module.exports = __webpack_public_path__ + "static/media/voucher-icon.af5151fc.svg";